import { Form } from 'antd';
import StyledForm, { Item } from './styles/form.style';

const NewForm = Object.assign(StyledForm(Form), {
  Item: Item(Form.Item),
});

export default NewForm;
